

// import { useLocation, useNavigate } from "react-router-dom";
// import { useState, useEffect } from "react";
// import { QRCodeCanvas } from "qrcode.react";
// import { db } from "./Firebase";
// import { doc, getDoc, collection, addDoc, updateDoc } from "firebase/firestore";
// import emailjs from '@emailjs/browser';
// import Swal from 'sweetalert2';
// import { QrReader } from 'react-qr-reader'; // Use react-qr-reader instead

// export default function Billing() {
//   const location = useLocation();
//   const navigate = useNavigate();

//   const [cart, setCart] = useState([]);
//   const [name, setName] = useState("");
//   const [contact, setContact] = useState("");
//   const [address, setAddress] = useState("");
//   const [paymentMethod, setPaymentMethod] = useState("");
//   const [confirmedOrders, setConfirmedOrders] = useState([]);
//   const [isMobile, setIsMobile] = useState(false);
//   const [orderCount, setOrderCount] = useState(0);
//   const [scanning, setScanning] = useState(false); // To toggle QR scanner

//   useEffect(() => {
//     const userEmail = localStorage.getItem("email");

//     if (!userEmail) {
//       Swal.fire("Oops!", "You have to login first to continue.", "warning");
//       navigate("/login");
//       return;
//     }

//     setIsMobile(/iphone|ipod|ipad|android/.test(navigator.userAgent.toLowerCase()));

//     const fetchCart = async () => {
//       try {
//         const cartRef = doc(db, "Cart", userEmail);
//         const cartSnap = await getDoc(cartRef);
//         if (cartSnap.exists()) {
//           setCart(cartSnap.data().items || []);
//         }
//       } catch (err) {
//         console.error("Failed to fetch cart:", err);
//       }
//     };

//     fetchCart();

//     const storedName = localStorage.getItem("fullName");
//     const storedContact = localStorage.getItem("contactNumber");
//     const storedAddress = localStorage.getItem("address");
//     const storedOrders = localStorage.getItem("orders");

//     if (storedName) setName(storedName);
//     if (storedContact) setContact(storedContact);
//     if (storedAddress) setAddress(storedAddress);
//     if (storedOrders) {
//       const orders = JSON.parse(storedOrders);
//       const confirmed = orders.filter(o => o.status === "confirmed" || o.status === "completed");
//       setConfirmedOrders(confirmed);
//       setOrderCount(confirmed.length);
//     }
//   }, [navigate]);

//   const deliveryCharge = 40;

//   const totalAmount = (
//     cart.reduce((total, item) => total + Number(item.Price) * item.quantity, 0) + deliveryCharge
//   ).toFixed(2);

//   const validateInputs = () => {
//     if (!cart.length) {
//       Swal.fire("Empty Cart", "Your cart is empty. Please add items before placing an order.", "info");
//       return false;
//     }
//     if (!/^\d{10}$/.test(contact)) {
//       Swal.fire("Invalid Input", "Contact number must be exactly 10 digits.", "error");
//       return false;
//     }
//     if (!paymentMethod) {
//       Swal.fire("Missing Info", "Please select a payment method.", "info");
//       return false;
//     }
//     if (!name.trim() || !address.trim()) {
//       Swal.fire("Missing Info", "Please fill in all required fields.", "info");
//       return false;
//     }
//     return true;
//   }

//   const submitOrder = async () => {
//     const order = {
//       orderId: Date.now(),
//       status: "pending",
//       totalAmount,
//       paymentMethod,
//       items: cart,
//       name,
//       contact,
//       address,
//       email: localStorage.getItem("email") || "user@example.com",
//       createdAt: new Date().toISOString(),
//     };

//     try {
//       await addDoc(collection(db, "Billing"), order);
//       await addDoc(collection(db, "Orders"), order);

//       sendAdminNotification(order);
//       sendEmail(order);
//       storeEmailDataToFirestore(order);

//       await clearCart();

//       Swal.fire("Thank you!", "Your order has been placed successfully.", "success").then(() => {
//         navigate("/");
//       });
//     } catch (err) {
//       console.error("Error saving billing info to Firestore:", err);
//       Swal.fire("Order Failed", `Failed to place order. Error: ${err.message}`, "error");
//     }
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     if (!validateInputs()) return;
//     await submitOrder();
//   };

//   const clearCart = async () => {
//     const userEmail = localStorage.getItem("email");
//     try {
//       await updateDoc(doc(db, "Cart", userEmail), {
//         items: [],
//       });
//       setCart([]);
//     } catch (err) {
//       console.error("Error clearing cart:", err);
//     }
//   };

//   const generateUPIURL = () => {
//     const upiID = "karanksxxx-1@oksbi";
//     const storeName = "KP Bakers";
//     const amount = parseFloat(totalAmount);
//     return `upi://pay?pa=${upiID}&pn=${encodeURIComponent(storeName)}&am=${amount}&cu=INR`;
//   };

//   // When user clicks Pay Now: redirect for mobile or open scanner for desktop
//   const handlePayNow = () => {
//     if (!cart.length) {
//       Swal.fire("Empty Cart", "Your cart is empty. Please add items before placing an order.", "info");
//       return;
//     }
//     if (!validateInputs()) return;

//     if (isMobile) {
//       // On mobile, redirect to UPI app and then submit order automatically
//       window.location.href = generateUPIURL();
//       // Note: can't detect payment completion reliably, so optionally you can ask user to confirm manually
//       // For demo, we'll submit order immediately
//       submitOrder();
//     } else {
//       // On desktop, open scanner to scan payment confirmation QR or show QR code
//       setScanning(true);
//       Swal.fire("Scan QR", "Please scan the payment confirmation QR code to complete your order.");
//     }
//   };

//   const sendAdminNotification = (order) => {
//     console.log("Admin Notification: New order received", order);
//   };

//   const sendEmail = (order) => {
//     const templateParams = {
//       user_name: order.name,
//       user_email: localStorage.getItem("email") || "user@example.com",
//       contact_number: order.contact,
//       address: order.address,
//       payment_method: order.paymentMethod,
//       order_id: order.orderId,
//       order_items: order.items.map(item => `${item.Name} (x${item.quantity}) - ₹${item.Price * item.quantity}`).join(", "),
//       total: order.totalAmount,
//     };

//     emailjs.send('service_nn606kn', 'template_j8omi6i', templateParams, 'CVy20pZ0JQ_XxmyCq')
//       .then((result) => {
//         console.log("Email sent successfully:", result.text);
//       }, (error) => {
//         console.error("Failed to send email:", error);
//       });
//   };

//   const storeEmailDataToFirestore = async (order) => {
//     try {
//       const emailContent = {
//         user_name: order.name,
//         user_email: localStorage.getItem("email") || "user@example.com",
//         contact_number: order.contact,
//         address: order.address,
//         payment_method: order.paymentMethod,
//         order_id: order.orderId,
//         order_items: order.items.map(item => `${item.Name} (x${item.quantity}) - ₹${item.Price * item.quantity}`).join(", "),
//         total: order.totalAmount,
//         sentAt: new Date().toISOString(),
//       };

//       await addDoc(collection(db, "SentEmails"), emailContent);
//       console.log("Email data stored in Firestore.");
//     } catch (err) {
//       console.error("Failed to store email data:", err);
//     }
//   };

//   const handleScanResult = async (result, error) => {
//     if (!!result) {
//       setScanning(false);
//       // You can verify scanned QR code content here if needed
//       Swal.fire("Payment Confirmed", "Payment QR scanned successfully, order will be placed.", "success");
//       await submitOrder();
//     }
//     if (!!error) {
//       // Optionally show error or ignore
//       // console.error(error);
//     }
//   };

//   return (
//     <div style={styles.billingContainer}>
//       <h1 className="text-center text-white mb-4 display-3 font-weight-bold">Billing Information</h1>
//       <div className="row justify-content-center">
//         <div className="col-md-8">
//           <div className="card shadow-lg p-4" style={styles.card}>
//             <div className="card-body">
//               {cart.length === 0 && (
//                 <div className="alert alert-info text-center">
//                   Your cart is empty. Please add some items to place an order.
//                 </div>
//               )}

//               {!scanning ? (
//                 <form onSubmit={handleSubmit} style={styles.forms}>
//                   <div className="form-group">
//                     <label>Full Name</label>
//                     <input
//                       type="text"
//                       className="form-control"
//                       value={name}
//                       onChange={(e) => setName(e.target.value)}
//                       required
//                     />
//                   </div>

//                   <div className="form-group">
//                     <label>Contact Number</label>
//                     <input
//                       type="text"
//                       className="form-control"
//                       value={contact}
//                       maxLength={10}
//                       onChange={(e) => {
//                         const value = e.target.value;
//                         if (/^\d*$/.test(value)) {
//                           setContact(value);
//                         }
//                       }}
//                       required
//                     />
//                   </div>

//                   <div className="form-group">
//                     <label>Address</label>
//                     <textarea
//                       className="form-control"
//                       rows="4"
//                       value={address}
//                       onChange={(e) => setAddress(e.target.value)}
//                       required
//                     />
//                   </div>

//                   <div className="mt-4">
//                     <h4>Items in your Cart:</h4>
//                     <ul className="list-group">
//                       {cart.map((item) => (
//                         <li
//                           key={item.id}
//                           className="list-group-item d-flex justify-content-between"
//                         >
//                           {item.Name} (x{item.quantity}) — ₹
//                           {(item.Price * item.quantity).toFixed(2)}
//                         </li>
//                       ))}
//                     </ul>
//                     <h4 className="text-light mt-4">
//                       Total (incl. ₹{deliveryCharge} delivery): ₹{totalAmount}
//                     </h4>
//                   </div>

//                   <div className="form-group mt-4 text-light">
//                     <label>Select Payment Method</label>
//                     <select
//                       className="form-control"
//                       value={paymentMethod}
//                       onChange={(e) => setPaymentMethod(e.target.value)}
//                       required
//                     >
//                       <option value="">-- Choose Payment Method --</option>
//                       <option value="gpay">Google Pay (UPI)</option>
//                       <option value="cod">Cash on Delivery</option>
//                     </select>
//                   </div>

//                   {paymentMethod === "gpay" && (
//                     <div className="mt-4 text-light">
//                       <h5>Google Pay UPI</h5>
//                       <p>Make payment to:</p>
//                       <p>
//                         <strong>UPI ID: karanksxxx-1@oksbi</strong>
//                       </p>
//                       <p>
//                         <strong>UPI Number: 9041429065</strong>
//                       </p>

//                       {!isMobile && (
//                         <>
//                           <QRCodeCanvas value={generateUPIURL()} size={256} />
//                           <p>After payment, click Submit or Pay Now to confirm the order.</p>
//                         </>
//                       )}

//                       {isMobile && (
//                         <div className="text-center mt-3">
//                           <button
//                             type="button"
//                             onClick={handlePayNow}
//                             className="btn btn-primary"
//                           >
//                             Pay Now
//                           </button>
//                         </div>
//                       )}

//                       <p className="mt-2">
//                         You can also make online payment at the time of delivery.
//                       </p>
//                     </div>
//                   )}

//                   <div className="text-center mt-4">
//                     <button
//                       type="submit"
//                       className="btn btn-success"
//                       disabled={cart.length === 0}
//                     >
//                       Submit Order
//                     </button>
//                   </div>
//                 </form>
//               ) : (
//                 <div>
//                   <h4 className="text-center text-light mb-3">
//                     Scan Payment Confirmation QR Code
//                   </h4>
//                   <QrReader
//                     constraints={{ facingMode: 'environment' }}
//                     onResult={handleScanResult}
//                     style={{ width: "100%" }}
//                   />
//                   <div className="text-center mt-3">
//                     <button
//                       className="btn btn-danger"
//                       onClick={() => setScanning(false)}
//                     >
//                       Cancel
//                     </button>
//                   </div>
//                 </div>
//               )}
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }

// const styles = {
//   billingContainer: {
//     backgroundImage:
//       "linear-gradient(45deg, #cbccc5, #03121a, #03121a, #cbccc5)",
//     minHeight: "100vh",
//     paddingTop: "3rem",
//   },
//   card: {
//     backgroundColor: "#263e55",
//     borderRadius: "15px",
//   },
//   forms: {
//     color: "white",
//   },
// };



import { useLocation, useNavigate } from "react-router-dom";
import { useState, useEffect, useRef } from "react";
import { QRCodeCanvas } from "qrcode.react";
import { db } from "./Firebase";
import { doc, getDoc, collection, addDoc, updateDoc } from "firebase/firestore";
import emailjs from "@emailjs/browser";
import Swal from "sweetalert2";
import { QrReader } from "react-qr-reader";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";

export default function Billing() {
  const navigate = useNavigate();
  const [cart, setCart] = useState([]);
  const [name, setName] = useState("");
  const [contact, setContact] = useState("");
  const [address, setAddress] = useState("");
  const [paymentMethod, setPaymentMethod] = useState("");
  const [isMobile, setIsMobile] = useState(false);
  const [scanning, setScanning] = useState(false);
  const invoiceRef = useRef(null);
  const deliveryCharge = 40;

  const totalAmount = (
    cart.reduce((total, item) => total + Number(item.Price) * item.quantity, 0) + deliveryCharge
  ).toFixed(2);

  useEffect(() => {
    const email = localStorage.getItem("email");
    if (!email) {
      Swal.fire("Oops!", "Login first to continue.", "warning");
      navigate("/login");
      return;
    }

    setIsMobile(/iphone|ipod|ipad|android/.test(navigator.userAgent.toLowerCase()));

    const fetchCart = async () => {
      const cartRef = doc(db, "Cart", email);
      const cartSnap = await getDoc(cartRef);
      if (cartSnap.exists()) setCart(cartSnap.data().items || []);
    };
    fetchCart();

    setName(localStorage.getItem("fullName") || "");
    setContact(localStorage.getItem("contactNumber") || "");
    setAddress(localStorage.getItem("address") || "");

    if (localStorage.getItem("paymentInProgress") === "true") {
      localStorage.removeItem("paymentInProgress");
      submitOrder();
    }
  }, [navigate]);

  const validateInputs = () => {
    if (!cart.length) return Swal.fire("Empty Cart", "Add items to cart first.", "info");
    if (!/^\d{10}$/.test(contact)) return Swal.fire("Invalid Contact", "10 digits only.", "error");
    if (!paymentMethod) return Swal.fire("Missing Info", "Select payment method.", "info");
    if (!name.trim() || !address.trim()) return Swal.fire("Missing Info", "Fill all fields.", "info");
    return true;
  };

  const generateUPIURL = () => {
    return `upi://pay?pa=karanksxxx-1@oksbi&pn=KP%20Bakers&am=${parseFloat(totalAmount)}&cu=INR`;
  };

  const clearCart = async () => {
    const email = localStorage.getItem("email");
    await updateDoc(doc(db, "Cart", email), { items: [] });
    setCart([]);
  };

  const submitOrder = async () => {
    const order = {
      orderId: Date.now(),
      name,
      contact,
      address,
      email: localStorage.getItem("email"),
      totalAmount,
      paymentMethod,
      status: "pending",
      items: cart,
      createdAt: new Date().toISOString(),
    };

    try {
      await addDoc(collection(db, "Billing"), order);
      await addDoc(collection(db, "Orders"), order);
      await clearCart();
      sendEmail(order);
      storeEmailData(order);

      Swal.fire("Order Placed!", "Thank you for your purchase.", "success").then(() => {
        navigate("/");
      });
    } catch (err) {
      Swal.fire("Error", err.message, "error");
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validateInputs() !== true) return;
    submitOrder();
  };

  const handlePayNow = () => {
    if (!validateInputs()) return;
    if (isMobile) {
      localStorage.setItem("paymentInProgress", "true");
      window.location.href = generateUPIURL();
    } else {
      setScanning(true);
      Swal.fire("Scan to Pay", "Use any UPI app to complete payment.");
    }
  };

  const handleScanResult = async (result, error) => {
    if (result) {
      setScanning(false);
      Swal.fire("Payment Confirmed", "QR scanned, order will be placed.", "success");
      await submitOrder();
    }
  };

  const sendEmail = (order) => {
    const templateParams = {
      user_name: order.name,
      user_email: order.email,
      contact_number: order.contact,
      address: order.address,
      payment_method: order.paymentMethod,
      order_id: order.orderId,
      order_items: order.items.map(i => `${i.Name} (x${i.quantity}) - ₹${i.Price * i.quantity}`).join(", "),
      total: order.totalAmount,
    };

    emailjs.send('service_nn606kn', 'template_j8omi6i', templateParams, 'CVy20pZ0JQ_XxmyCq')
      .then(res => console.log("Email sent:", res.text))
      .catch(err => console.error("Email error:", err));
  };

  const storeEmailData = async (order) => {
    const content = { ...order, sentAt: new Date().toISOString() };
    await addDoc(collection(db, "SentEmails"), content);
  };

  const downloadInvoice = () => {
    html2canvas(invoiceRef.current).then((canvas) => {
      const img = canvas.toDataURL("image/png");
      const pdf = new jsPDF();
      pdf.addImage(img, "PNG", 10, 10, 190, 0);
      pdf.save(`Invoice_${Date.now()}.pdf`);
    });
  };

  return (
    <div style={styles.billingContainer}>
      <div className="container py-4">
        <h2 className="text-white text-center mb-4">Billing & Invoice</h2>
        <div ref={invoiceRef} style={styles.invoiceBox}>
          <h3>KP Bakers</h3>
          <p><strong>Issued to:</strong> {name}</p>
          <p><strong>Invoice no:</strong> 2025-{Date.now()}</p>
          <p><strong>Date issued:</strong> {new Date().toLocaleDateString()}</p>
          <table style={styles.table}>
            <thead>
              <tr>
                <th>QTY</th>
                <th>PRICE</th>
                <th>DESCRIPTION</th>
                <th>TOTAL</th>
              </tr>
            </thead>
            <tbody>
              {cart.map((item) => (
                <tr key={item.id}>
                  <td>{item.quantity}</td>
                  <td>₹{item.Price}</td>
                  <td>{item.Name}</td>
                  <td>₹{(item.Price * item.quantity).toFixed(2)}</td>
                </tr>
              ))}
              <tr>
                <td colSpan="3">Delivery</td>
                <td>₹{deliveryCharge}</td>
              </tr>
              <tr style={{ fontWeight: "bold" }}>
                <td colSpan="3">TOTAL</td>
                <td>₹{totalAmount}</td>
              </tr>
            </tbody>
          </table>
        </div>

        <div className="text-center mt-4">
          <button className="btn btn-outline-light mb-2" onClick={downloadInvoice}>Download Invoice</button>
        </div>

        <form onSubmit={handleSubmit} style={styles.forms}>
          <input type="text" className="form-control my-2" placeholder="Full Name" value={name} onChange={(e) => setName(e.target.value)} required />
          <input type="text" className="form-control my-2" placeholder="Contact Number" value={contact} onChange={(e) => setContact(e.target.value)} required />
          <textarea className="form-control my-2" rows="3" placeholder="Address" value={address} onChange={(e) => setAddress(e.target.value)} required />

          <select className="form-control my-2" value={paymentMethod} onChange={(e) => setPaymentMethod(e.target.value)} required>
            <option value="">-- Select Payment Method --</option>
            <option value="gpay">Google Pay (UPI)</option>
            <option value="cod">Cash on Delivery</option>
          </select>

          {paymentMethod === "gpay" && (
            <div className="text-center mb-3">
              <QRCodeCanvas value={generateUPIURL()} size={180} />
              <p className="text-light">Scan & Pay. Then click Submit.</p>
              {isMobile && (
                <button type="button" onClick={handlePayNow} className="btn btn-primary">Pay Now</button>
              )}
            </div>
          )}

          <button className="btn btn-success btn-block mt-3" type="submit" disabled={!cart.length}>
            Submit Order
          </button>
        </form>

        {scanning && (
          <div className="mt-3">
            <h5 className="text-white text-center">Scan Payment QR</h5>
            <QrReader constraints={{ facingMode: 'environment' }} onResult={handleScanResult} style={{ width: "100%" }} />
            <button onClick={() => setScanning(false)} className="btn btn-danger mt-2 d-block mx-auto">Cancel</button>
          </div>
        )}
      </div>
    </div>
  );
}

const styles = {
  billingContainer: {
    backgroundImage: "linear-gradient(45deg, #cbccc5, #03121a, #03121a, #cbccc5)",
    minHeight: "100vh",
    paddingTop: "2rem",
  },
  invoiceBox: {
    background: "#000",
    color: "#fff",
    padding: "25px",
    borderRadius: "10px",
    boxShadow: "0 0 10px #fff",
  },
  table: {
    width: "100%",
    marginTop: "20px",
    borderCollapse: "collapse",
    color: "#fff",
  },
  forms: {
    marginTop: "30px",
    color: "white",
  },
};


























//                                  // PAYMENT GATEWAY CODE


// // CALCULATE TOTAL AMOUNT:-
// const totalAmount = (
//   cart.reduce((total, item) => total + Number(item.Price) * item.quantity, 0) + deliveryCharge
// ).toFixed(2);
// // (get total of items in cart by multiplying price and quantity, add delivery charge and remove that item after order placed)



//  const generateUPIURL = () => {
//     const upiID = "karanksxxx-1@oksbi";    //add your upi id here
//     const storeName = "KP Bakers";          //add your store name here
//     const amount = parseFloat(totalAmount);    //amount to be paid
//     return `upi://pay?pa=${upiID}&pn=${encodeURIComponent(storeName)}&am=${amount}&cu=INR`;   // generate a upi url relevant to your store name and amount and upi id
//   };
//   // generate upi url for payment gateway by adding upi id, store name and amount to be paid



// <QRCodeCanvas value={generateUPIURL()} size={256} />
// // create a qr code for payment

// const handlePayNow = () => {

//   if (isMobile) {
//     localStorage.setItem("paymentInProgress", "true");     // check if payment is in progress  or confirmed
//     window.location.href = generateUPIURL(); // Redirect to UPI app
//   } else {
//     setScanning(true); // Show QR scanner for desktop
//     Swal.fire("Scan QR", "Please scan the payment confirmation QR code to complete your order.");   //swal is a library for alert box
//   }
// };
// // its for redirecting to upi app if mobile user and for showing qr scanner if desktop user
